<script setup>
import axios  from "axios";
import moment  from "moment";
import { saveAs } from 'file-saver';
import Dialogmedia from '@/components/neta/Dialogmedia.vue';
import Freedialog from '@/components/release_create/FreeDialog.vue';
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-sheet
    width="100%"
    class="pl-2"
    style="text-align:  center;"
>
    <v-container fluid fill-height v-if="loading" style="height: 500px;">
      <v-layout justify-center align-center>
        <v-progress-circular :indeterminate="true" size="64" color="accent" />
      </v-layout>
    </v-container>


<v-toolbar
    flat
    tile
    v-if="loading==false"
    width="95%"
    height="50px"
	class="mr-0 pr-0"
>
	<div class="recommess">
		<v-icon class="mx-1">mdi-email</v-icon>や<v-icon class="mx-1">mdi-application</v-icon>などのアイコンが表示されているメディアは<v-icon class="mx-1">mdi-cloud-download-outline</v-icon>から連絡先をダウンロードできます。
	</div>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            v-on="on"
            v-bind="attrs"
            @click="getrecom"
        >
            <v-icon
            >
                mdi-refresh
            </v-icon>
        </v-btn>
        </template>
        <span>更新</span>
    </v-tooltip>

    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            v-on="on"
            v-bind="attrs"
            @click="download"
        >
            <v-icon
            >
                mdi-cloud-download-outline
            </v-icon>
        </v-btn>
        </template>
        <span>ダウンロード</span>
    </v-tooltip>
</v-toolbar>
<v-list
    dense
>
    <v-list-item 
        v-for="item in recom_edit_list"
		:key="item.id"
    >
			<v-row>
			<v-col cols="3" class="py-2">
                      <v-img
                        :src="`https://search.qlipper.jp/cont/mdimg?site_id=` + item.id"
                        :aspect-ratio="16/9"
                        class="grey lighten-2 rounded-lg"
                        style="text-align:end;"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
			</v-col>
			<v-col>
        <v-card 
			width="100%"
            style="text-align:left;"
            class="pl-3 pt-2 mb-3"
        >
            <v-card-title
                class="pt-2 pl-2 pb-3 mb-2 titlebox"
            >
                    <a :href="item.site_url" target="_blunk">
                        <h2 class="medianame">{{ item.site_name }}</h2>
                    </a>
                        <span v-if="item.mail_address1 != null || item.mail_address2 != null || item.mail_address3 != null" >
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    color="#E13533"
                                >
                                    mdi-email
                                </v-icon>
                            </template>
                            <span>メールアドレス</span>
                        </v-tooltip>
                        </span>
                           <span v-if="item.relurl != null">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    color="#E13533"
                                >
                                    mdi-application-outline
                                   </v-icon>
                            </template>
                            <span>送信フォーム</span>
                        </v-tooltip>
                           </span>
                           <span v-if="item.fax_no != null">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    color="#E13533"
                                >
                                    mdi-fax
                                   </v-icon>
                            </template>
                            <span>Fax番号</span>
                        </v-tooltip>
                           </span>

            </v-card-title>
            <v-card-subtitle
                class="pt-1 pl-2 pb-3 pr-0"
            >
                <a :href=item.site_url target="_blank">{{ item.site_url }}</a>
            </v-card-subtitle>
            <v-card-text
                class="pt-0 pl-0 pb-1 pr-1"
            >
                <v-container
                        class="pt-0 pl-1 pr-0"
                >
                <v-row
                    dense
                >
                    <v-col
                        class="pt-0"
                        cols = "10"    
                    >
                        <span class="publisher">{{item.publisher}}</span>
                    </v-col>
                    <v-col
                        style="text-align:right"
						v-if="item.mail_address1 != null || item.mail_address2 != null || item.mail_address3 != null || item.relurl !=  null"
                    >
						<v-btn
							color="#E11D31"
							dark
							@click="medialist(item.site_id)"
							class="mb-2"
						>
							<v-icon>
								mdi-plus
							</v-icon>
							リスト候補に追加
						</v-btn>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
        </v-card>
		</v-col>
		</v-row>
    </v-list-item>
</v-list>
<Dialogmedia
    ref="media"
>
</Dialogmedia>
<Freedialog
    ref="free"
>
</Freedialog>

</v-sheet>
</template>
<script>
export default{
  head: {
    title() {
      return {
        inner: 'おすすめメディア',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },
    props : ["therm","kind","keyword","tag"],
    computed: {
        _allquery() {
              return [this.therm, this.kind,this.keyword,this.tag];
        },
		pay_flg : function(){
			return this.$store.getters["member_info/get_pay_flg"];
		},
    },
    watch : {
        _allquery() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.getrecom();
            }, 500);

        },
    },


    data () {
      return {
        recom_list : null,
        recom_edit_list : null,
        loading    : true,

      }
    },
    methods : {
        medialist : async function(site_id){
            let params = new URLSearchParams();
            params.append('site_id',site_id);
            params.append('mode',2);
            await axios.post("/api/media/set_media_list",params)
            .then(response => {
				this.$store.commit("mediacand/set_candlist",response.data);
            }).catch((error) => {
                //window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},
        openmedia : function(site_id){
            if(this.pay_flg!=true)
            {
                this.$refs.free.open();
                return;
            }

            this.$refs.media.open(site_id);
        },
        getrecom : async function(){
            var params = new URLSearchParams();
            params.append("keyword",this.keyword);
            params.append("tag",this.tag);
            if(this.therm != null && this.therm != "")
                params.append("category",this.therm);
            if(this.kind != null && this.kind != "")
                params.append("kind",this.kind);

            this.recom_list = [];
            this.loading = true;
            await axios.post("/api/release/get_simmedia",params)
            .then(response => {
                this.recom_list = response.data;
                this.recom_edit_list = this.recom_list;
                this.loading = false;
            }).catch((error) => {
                //window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        exclude  : function(event){
            const id = event.target.id ;

            for(let i=0; i < this.recom_edit_list.length ; i++)
            {
                if(this.recom_edit_list[i].id==id)
                {
                    this.recom_edit_list.splice(i,1);
                    break;
                }
            }
        },
        download : async function(){

            if(this.pay_flg!=true)
            {
                this.$refs.free.open();
                return;
            }
            let json_str = JSON.stringify(this.recom_edit_list);
            await axios.post("/api/release/get_media_download",json_str,{responseType: "blob"})
            .then(response => {
                const blob = new Blob([response.data], {
                    type: response.data.type
                });
                saveAs(blob, "download-"+moment().format('YYYY-MM-DD')+".csv");
            }).catch((error) => {
                //window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
    created : function(){
		/*
        var params = new URLSearchParams();
        axios.post("/api/contract/get_payflg",params)
        .then(response => {
            this.pay_flg = response.data.pay_flg;
            if(this.pay_flg==false)
            {
                this.$refs.freeslide.open();
            }
            else
            {
                this.free_init_flg=true;
            }
        }).catch((error) => {
                //window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });
		*/
        this.getrecom();
    },
  }
</script>
<style>
.titlebox{
  display: flex;
  justify-content: space-between;

}
.recommess{
  font-size:1.3rem;
  text-align:left;
}
.medianame{
    margin: 0;
    font-size: revert;
}
.publisher{
    font-weight: bold;
}
</style>
